<template>
    <el-dialog :visible.sync="visible" title="ЧС номеров" :append-to-body="true" width="600px">
        <div class="text-right"><HelpPopover style="font-size: 20px; padding-right: 5px" about="Инструкция по ЧС номеров" /></div>
        <BlacklistedPhonesBlock />
    </el-dialog>
</template>

<script>
import BlacklistedPhonesBlock from "./BlacklistedPhonesBlock.vue";
import HelpPopover from "../others/HelpPopover.vue";

export default {
    name: "BlacklistedPhonesManage",
    components: {HelpPopover, BlacklistedPhonesBlock},
    data: () => ({
        visible: false,
    }),
    mounted() {
        let self = this;
        this.$bus.$on('blacklisted_phones:open-manage', () => {
            self.visible = true;
        })
    }
}
</script>

<style scoped>

</style>
